<template>
    <UiContentwrapper>
        <UiNarrowcolumn>                            
          <slot></slot>
        </UiNarrowcolumn>
      </UiContentwrapper>
</template>